import { ModelType } from '../store/global-types/customization-types';
import { SupportedModelType } from '../store/appConfig/appDeploymentInfoTypes';

export enum TabKey {
    Contouring = 'contouring',
    Dose = 'dose',
    Image = 'image',
    Adapt = 'adapt'
}

export interface TabSelectionInput {
    currentModelType: ModelType | undefined;
    supportedModelTypes: SupportedModelType[];
    previousTabKey?: TabKey;
}

interface ModelTypeTab {
    type: ModelType;
    key: TabKey;
    isSupported: boolean;
}

/** Helper function to determine which tab should be active based on current model type and supported model types */
export const getNextActiveTab = (input: TabSelectionInput): TabKey | undefined => {
    const { currentModelType, supportedModelTypes, previousTabKey } = input;

    // Map model types to their corresponding tab keys and support flags
    const modelTypeToTab: ModelTypeTab[] = [
        { type: ModelType.Contouring, key: TabKey.Contouring, isSupported: supportedModelTypes.includes(SupportedModelType.Contour) },
        { type: ModelType.Dose, key: TabKey.Dose, isSupported: supportedModelTypes.includes(SupportedModelType.Dose) },
        { type: ModelType.Image, key: TabKey.Image, isSupported: supportedModelTypes.includes(SupportedModelType.Image) },
        { type: ModelType.Adapt, key: TabKey.Adapt, isSupported: supportedModelTypes.includes(SupportedModelType.Adapt) }
    ];

    // Get all supported tabs
    const supportedTabs = modelTypeToTab.filter(tab => tab.isSupported);

    // If no tabs are supported, return undefined
    if (supportedTabs.length === 0) {
        return undefined;
    }

    // If there's a previous tab key and it's still supported, keep it
    if (previousTabKey !== undefined) {
        const previousTab = supportedTabs.find(tab => tab.key === previousTabKey);
        if (previousTab) {
            return previousTab.key;
        }
    }

    // Try to set tab based on current model type
    const currentModelTab = supportedTabs.find(tab => 
        tab.type === currentModelType && tab.isSupported
    );
    if (currentModelTab) {
        return currentModelTab.key;
    }

    // If no previous tab or current model type is not supported, select the first supported tab
    return supportedTabs[0].key;
}; 